import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LOGIN_REDIRECT_KEY_PARAM_NAME, LoginRedirectService} from '@shared/services/routing/login-redirect.service';
import {NavigationUtils} from '@shared/util/general/navigation-utils';
import {AceLogger} from '@logging/ace-logger';
import {AceLoggerService} from '@logging/ace-logger.service';

@Component({
  selector: 'app-login-redirect',
  templateUrl: './login-redirect.component.html',
  styleUrl: './login-redirect.component.scss',
  standalone: false
})
export class LoginRedirectComponent implements OnInit {

  private readonly logger: AceLogger;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private loginRedirectService: LoginRedirectService,
              logService: AceLoggerService
  ) {
    this.logger = logService.create(LoginRedirectComponent.name);
  }

  ngOnInit(): void {
    const redirectKey = this.route.snapshot.queryParamMap.get(LOGIN_REDIRECT_KEY_PARAM_NAME);
    const targetUrl = this.loginRedirectService.takeTargetUrl(redirectKey);
    // Replacing rather than pushing keeps this route, whose stashed URL has now been taken, out of the browser's history.
    // The destination can redirect onward before this navigation completes, therefore passing true to ignoreOnNavigationFailed to avoid code throwing error.
    if (targetUrl) {
      NavigationUtils.onNavigated(this.router.navigateByUrl(targetUrl, {replaceUrl: true}), true);
    } else {
      this.logger.error(`No URL is stored against redirect key [${redirectKey}], redirecting to the home page instead`);
      NavigationUtils.onNavigated(this.router.navigate(['/'], {replaceUrl: true}), true);
    }
  }

}
